import { createAction, props } from '@ngrx/store';

import type { BookingStorePayload, Extras } from '../../models/booking';
import type { FiltersPaylod, VehicleFilterOptions } from '../../models/car-filters';
import type { LocationDetail } from '../../models/location-detail';

// car detail
export const setCarDetail = createAction(
  '[Web] Set Car Detail',
  props<{ carDetail: BookingStorePayload }>()
);

// location detail
export const setLocationDetail = createAction(
  '[Views] Set Location Detail',
  props<{ locationDetail: LocationDetail }>()
);

export const loadFilters = createAction(
  '[Web] Load Filters',
  props<{ payload: FiltersPaylod }>() // filters_payload
);

export const loadFiltersSuccess = createAction(
  '[Web] Load Filters Success',
  props<{ filters: VehicleFilterOptions }>() // response.data
);

export const loadFiltersFailure = createAction(
  '[Web] Load Filters Failure',
  props<{ error: unknown }>()
);

// autocomplete
export const loadLocationAutoComplete = createAction(
  '[Web] Load Location AutoComplete',
  props<{ searchValue: string }>()
);

export const loadLocationAutoCompleteSuccess = createAction(
  '[Web] Load Location AutoComplete Success',
  props<{ list: { name: string }[] }>()
);

export const loadLocationAutoCompleteFailure = createAction(
  '[Web] Load Location AutoComplete Failure'
);

// get extras
export const loadExtras = createAction('[Views] Load Extras');

export const loadExtrasSuccess = createAction(
  '[Views] Load Extras Success',
  props<{ extras: Extras[] }>()
);

export const loadExtrasFailure = createAction(
  '[Views] Load Extras Failure',
  props<{ error: unknown }>()
);

// clear state
export const clearWebState = createAction('[Web] Clear Web State');
